function FloatingCall() {

  const handleCallClick = () => {
    const light = document.getElementById("light");
    const fade = document.getElementById("fade");

    if (light) light.style.display = "block";
    if (fade) fade.style.display = "block";
  };

  return (
    <div className="floatingCall">

      <a
        href="tel:18005711030"
        onClick={handleCallClick}
        aria-label="Call Now"
      >
        <img
          src="/images/number.png"
          alt="Call Now"
          width="220"
          height="65"
          loading="eager"
          fetchPriority="high"
        />
      </a>

    </div>
  );
}

export default FloatingCall;